// extracted by css-extract-rspack-plugin
export default {"cls1":"CoauthorConfirmationCard-cls1_ehY","cls2":"CoauthorConfirmationCard-cls2_O11 CoauthorConfirmationCard-cls1_ehY"};